// extracted by mini-css-extract-plugin
export default {"notfound":"PageNotFound_notfound__TaJ29","notfound-content":"PageNotFound_notfound-content__f-rFm","notfound-sub-content":"PageNotFound_notfound-sub-content__WDDZ-"};